// NEOGRIPX — Comparador bici oscura / bici clara (snippet nx-compare)
// Arrastrar (ratón o dedo) mueve la línea; en móvil el scroll vertical sigue funcionando.
(function () {
  const box = document.querySelector('[data-nxc]');
  if (!box) return;
  const range = box.querySelector('[data-nxc-range]');
  const dark = box.querySelector('.nxc-dark');
  const light = box.querySelector('.nxc-light');
  let map = {};
  try { map = JSON.parse(box.querySelector('[data-nxc-map]').textContent); } catch (err) { map = {}; }
  const variantSelect = document.querySelector('#AddToCartForm .variant-id-select');
  let dragging = false;

  // Cada tipo de bici tiene su pareja de fotos; sin pareja se ve la foto normal
  const showFor = (id) => {
    const pair = map[id];
    if (!pair) { box.hidden = true; return; }
    // A pantalla completa se carga el original; en la ficha, la versión ligera
    const full = box.parentElement.classList.contains('is-full');
    const d = full ? pair.darkFull : pair.dark;
    const l = full ? pair.lightFull : pair.light;
    if (dark.getAttribute('src') !== d) dark.src = d;
    if (light.getAttribute('src') !== l) light.src = l;
    box.hidden = false;
  };
  if (variantSelect) {
    showFor(variantSelect.value);
    box.parentElement.addEventListener('nxz:open', () => { if (!box.hidden) showFor(variantSelect.value); });
    // El cambio de tipo de bici actualiza primero el selector (neogripx.js)
    document.querySelectorAll('.variant-radio').forEach((r) => r.addEventListener('change', () => setTimeout(() => showFor(variantSelect.value), 0)));
  }

  const setPos = (pct) => {
    const p = Math.max(0, Math.min(100, pct));
    box.style.setProperty('--pos', p + '%');
    range.value = Math.round(p);
  };
  const fromEvent = (e) => {
    const r = box.getBoundingClientRect();
    setPos(((e.clientX - r.left) / r.width) * 100);
  };

  box.addEventListener('pointerdown', (e) => {
    dragging = true;
    box.classList.add('is-dragging', 'is-touched');
    box.setPointerCapture(e.pointerId);
    fromEvent(e);
  });
  box.addEventListener('pointermove', (e) => { if (dragging) fromEvent(e); });
  const stop = () => { dragging = false; box.classList.remove('is-dragging'); };
  box.addEventListener('pointerup', stop);
  box.addEventListener('pointercancel', stop);
  range.addEventListener('input', () => { box.classList.add('is-touched'); setPos(+range.value); });

  // Pequeño vaivén para que se entienda que se mueve: al entrar en pantalla y
  // luego cada 4 s, hasta que el cliente la toca. Solo mientras se ve.
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    // 50 → 65 → 35 → 50 suavemente en 1,6 s
    const keys = [50, 65, 35, 50];
    const dur = 1600;
    const every = 4000;
    const ease = (t) => 0.5 - Math.cos(Math.PI * t) / 2;
    let visible = false;
    let timer = null;
    const stopped = () => box.classList.contains('is-touched');
    const wobble = () => {
      timer = null;
      if (stopped() || !visible) return;
      // Otra foto elegida o pestaña en segundo plano: se espera a la siguiente vuelta
      if (box.hidden || document.hidden) { timer = setTimeout(wobble, every); return; }
      let start = null;
      const tick = (now) => {
        if (stopped()) return;
        if (start === null) start = now;
        const t = Math.min(1, (now - start) / dur);
        const seg = Math.min(keys.length - 2, Math.floor(t * (keys.length - 1)));
        const local = t * (keys.length - 1) - seg;
        setPos(keys[seg] + (keys[seg + 1] - keys[seg]) * ease(local));
        if (t < 1) requestAnimationFrame(tick);
        else timer = setTimeout(wobble, every);
      };
      requestAnimationFrame(tick);
    };
    const io = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      if (visible && !timer && !stopped()) timer = setTimeout(wobble, 400);
    }, { threshold: 0.6 });
    io.observe(box);
  }

  // La comparación es la primera foto (la portada del tipo elegido): al elegir otra miniatura se oculta.
  // Las miniaturas se reordenan al cambiar de tipo, así que se mira la posición en el momento del clic.
  document.querySelectorAll('.product-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const first = thumb.parentElement.querySelector('.product-thumb:not(.thumb-hidden)');
      if (thumb === first && variantSelect) showFor(variantSelect.value);
      else box.hidden = true;
    });
  });
})();
